/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: none;
}

:host([show]) {
  padding: calc(6rem/14) 0;
  display: block;
  position: absolute;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background, #FFFFFF);
  max-width: calc(400rem/14);
  min-width: -webkit-max-content;
  min-width: -moz-max-content;
  min-width: max-content;
  width: 100%;
  border: 1px solid var(--davinci-color-outline,#8E989D);
  max-height: calc(336rem/14);
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 100;
  line-height: calc(24rem/14);
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}
:host([show]) .item {
  display: flex;
  padding: calc(6rem/14) calc(16rem/14);
  cursor: pointer;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background, #FFFFFF);
  white-space: nowrap;
}
:host([show]) .item em {
  font-style: normal;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  font-weight: 600;
}
:host([show]) .item:hover {
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
}
:host([show]) #activeitem {
  background-color: var(--davinci-color-background-3,#EEEFF0) !important;
  border-left: calc(6rem/14) solid var(--davinci-color-primary-light,#009DF4);
  padding-left: calc(10rem/14);
}

:host([opentop]) {
  border-top: none;
}

:host([hidden]) {
  display: none;
}`;
export { style };
